
import jsPDF from "jspdf";
import { GeneralResponse, IDrug } from "../../interface/GeneralResponse";


  export const getDrugDisplayName = (drug: IDrug): string => {
    return drug.Name || drug.DrugName || "";
  };


export const cleanFormData = (data: any): any => {
  if (Array.isArray(data)) {
    // Special handling for Drugs array
    if (data.length > 0 && "PackageId" in data[0]) {
      return data.map((drug) => {
        const cleaned: any = {};

        Object.entries(drug).forEach(([key, value]) => {
          if (
            value !== null &&
            value !== undefined &&
            value !== "" &&
            value !== 0 &&
            // For arrays, only add if not empty
            !(Array.isArray(value) && value.length === 0)
          ) {
            cleaned[key] = value;
          }
        });

        // Handle DrugName for external drugs
        if (!cleaned.DrugName && drug.Name) {
          cleaned.DrugName = drug.Name;
        }

        if (drug.MealCode) {
          cleaned.Meal = drug.MealCode;
        }
        if (drug.FrequencyCode) {
          cleaned.Frequency = drug.FrequencyCode;
        }
 
        if (!cleaned.DrugName) {
          cleaned.DrugName = drug.Name || "Unknown Drug";
        }
 
        if (cleaned.PackageId === undefined) {
          cleaned.PackageId = null;
        }

        return cleaned;
      });
    }
    // For other arrays
    return data.map(cleanFormData).filter((item) => {
      if (typeof item === "object") {
        return Object.keys(item).length > 0;
      }
      return item !== null && item !== undefined && item !== "" && item !== 0;
    });
  }

  if (typeof data === "object" && data !== null) {
    const cleaned: any = {};
    for (const [key, value] of Object.entries(data)) {
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== 0
      ) {
        if (typeof value === "object") {
          const cleanedValue = cleanFormData(value);
          if (Object.keys(cleanedValue).length > 0) {
            cleaned[key] = cleanedValue;
          }
        } else {
          cleaned[key] = value;
        }
      }
    }
    return cleaned;
  }

  return data;
};


export const handleExportPDF = (pdfData: GeneralResponse<any>) => {
    try {
      // Decode Base64 content
      const byteCharacters = atob(pdfData?.Data?.FileContents);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);

      // Create Blob from the byteArray
      const blob = new Blob([byteArray], { type: "application/pdf" });

      // Use jsPDF to save it
      const pdf = new jsPDF();
      const objectUrl = URL.createObjectURL(blob);
      // Direct download if supported
      // if (isPrint) {
        // Create an invisible iframe to load the PDF
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        iframe.src = objectUrl;
        document.body.appendChild(iframe);

        iframe.onload = () => {
          iframe.contentWindow?.focus(); // Focus on the PDF
          iframe.contentWindow?.print(); // Open the print dialog
        };
      // } else {
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = pdfData?.Data?.FileDownloadName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      // }
    } catch (error: any) {
      // showToast(
      //   // GetPdfError?.message ??
      //   error?.message ?? t("an_error_occurred_please_try_again"),
      //   "error",
      // );
    }
  };